import { defineMessages } from "react-intl";

export default defineMessages({
  login: {
    id: "login",
    defaultMessage: "Login",
  },
  email: {
    id: "email",
    defaultMessage: "Email",
  },
  password: {
    id: "password",
    defaultMessage: "Password",
  },
  register: {
    id: "register",
    defaultMessage: "Register",
  },
  forgot_password: {
    id: "forgot_password",
    defaultMessage: "Forgot password",
  },
  name: {
    id: "name",
    defaultMessage: "Full name",
  },
  confirm_password: {
    id: "confirm_password",
    defaultMessage: "Confirm password / Confirmar Contraseña",
  },
  submit: {
    id: "submit",
    defaultMessage: "Submit",
  },
  passwords_do_not_match: {
    id: "passwords_do_not_match",
    defaultMessage: "Passwords do not match / Las contraseñas no coinciden",
  },
  error: {
    id: "error",
    defaultMessage: "Failed",
  },
  success: {
    id: "success",
    defaultMessage: "Success",
  },
  registration_success_message: {
    id: "registration_success_message",
    defaultMessage: "Registration successful / Registro Existoso",
  },
  forgot_password_message: {
    id: "forgot_password_message",
    defaultMessage:
      "Password reset link sent to your registered email id / El enlace para reiniciar la contraseña fue enviado al correo electronico registrado",
  },
  invalid_email: {
    id: "invalid_email",
    defaultMessage: "Invalid Email",
  },
  reset_password: {
    id: "reset_password",
    defaultMessage: "Reset password",
  },
  reset_password_success: {
    id: "reset_password_success",
    defaultMessage:
      "Password reset successfully / Restablecimiento de contraseña exitoso",
  },
  invalid_token: {
    id: "invalid_token",
    defaultMessage: "Invalid Token / Token no válido",
  },
});
